import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Comprehensive, authentic student data matching the uploaded AI achievement cards
export const authenticChampions = [
  {
    id: 1,
    name: "Mohammed Aflakh",
    rank: "2nd Place",
    category: "podium",
    division: "State Level",
    points: "5/5 Points",
    coach: "Mr. Sivarajan",
    event: "Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Aflakh! Your hard work brings great success!",
    image: "/images/students/mohammed-aflakh.jpeg"
  },
  {
    id: 2,
    name: "Shankar Thilak",
    rank: "2nd Place in U-13",
    category: "podium",
    division: "U-13",
    points: null,
    coach: "Mr. Sivarajan",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Shankar! Outstanding strategic play in U-13.",
    image: "/images/students/shankar-thilak.jpeg"
  },
  {
    id: 3,
    name: "Varnith",
    rank: "4th Place",
    category: "podium",
    division: "State Level",
    points: null,
    coach: "Mr. V. S. Kalyanaraghavan",
    event: "State Level Chess Tournament",
    date: "2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Varnith! Your hard work brings great success!",
    image: "/images/students/varnith.jpeg"
  },
  {
    id: 4,
    name: "Aditi Suresh",
    rank: "5th Place",
    category: "podium",
    division: "State Level",
    points: null,
    coach: "Mr. Govindarajan",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Aditi! Your hard work brings great success!",
    image: "/images/students/aditi-suresh.jpeg"
  },
  {
    id: 5,
    name: "Sai Adhira",
    rank: "7th Place in U-9",
    category: "ageGroup",
    division: "U-9",
    points: null,
    coach: "Ms. Vishnupriya",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Adhira! Your hard work brings great success!",
    image: "/images/students/sai-adhira.jpeg"
  },
  {
    id: 6,
    name: "Sai Deekshitha",
    rank: "9th Place in U-9",
    category: "ageGroup",
    division: "U-9",
    points: null,
    coach: "Ms. Vishnupriya",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Deekshitha! Your hard work brings great success!",
    image: "/images/students/sai-deekshitha.jpeg"
  },
  {
    id: 7,
    name: "Ajay",
    rank: "9th Place in U-11",
    category: "ageGroup",
    division: "U-11",
    points: null,
    coach: "Mr. Rajendran",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Ajay! Your hard work brings great success!",
    image: "/images/students/ajay.jpeg"
  },
  {
    id: 8,
    name: "Dheeran Raj",
    rank: "13th Place in U-9",
    category: "ageGroup",
    division: "U-9",
    points: null,
    coach: "Ms. Vishnupriya",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Dheeran! Your hard work brings great success!",
    image: "/images/students/dheeran-raj.jpeg"
  },
  {
    id: 9,
    name: "Pranav Babu",
    rank: "20th Place",
    category: "state",
    division: "State Level",
    points: null,
    coach: "Thirumal Coaching Team",
    event: "State Level Chess Tournament",
    date: "2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Congratulations Pranav Babu for securing 20th Place!",
    image: "/images/students/pranav-babu.jpeg"
  },
  {
    id: 10,
    name: "Lishanth",
    rank: "21st Place",
    category: "fide",
    division: "FIDE Classical",
    points: null,
    coach: "Mr. V. S. Kalyanaraghavan",
    event: "Eight Square FIDE Rated Classical Tournament",
    date: "2026",
    venue: "Chennai",
    typeBadge: "FIDE RATED",
    quote: "Well Done Lishanth! Outstanding FIDE Classical performance.",
    image: "/images/students/lishanth.jpeg"
  },
  {
    id: 11,
    name: "Mohammed Wasama",
    rank: "23rd Place",
    category: "state",
    division: "State Level",
    points: "3/6 Points",
    coach: "Mr. Sivarajan",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Chennai",
    typeBadge: "STATE MATCH",
    quote: "Well Done Wasama! Your hard work brings great success!",
    image: "/images/students/mohammed-wasama.jpeg"
  },
  {
    id: 12,
    name: "Arjun",
    rank: "6th Place in U-17",
    category: "ageGroup",
    division: "U-17",
    points: "3/4",
    prize: null,
    rating: null,
    coach: "Mr. Kalyanaraghavan",
    event: "1st S3 Chess Academy Tamil Nadu State Level Chess Competition",
    date: "10-10-2026",
    venue: "Dr. A.P.J Abdul Kalam Cantonment School",
    typeBadge: "STATE MATCH",
    quote: "Well Done Arjun! Your hard work brings great success!",
    image: "/images/students/arjun.jpeg"
  },
  {
    id: 13,
    name: "Siva Chidambaram",
    rank: "6th Place in U-17",
    category: "fide",
    division: "U-17",
    points: "5.5/9",
    prize: "₹ 12,500",
    rating: "1484 - 1608",
    coach: "Mr. Kalyanaraghavan",
    event: "Eight Square Chess Academy 3rd International Fide Rated Open Chess Tournament 2026",
    date: "7th to 11th Oct 2026",
    venue: "Chennai",
    typeBadge: "FIDE RATED",
    quote: "Well Done Siva! Your hard work brings great success!",
    image: "/images/students/siva-chidambaram.jpeg"
  },
];

export const HallOfFame = ({ students = authenticChampions }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [coachFilter, setCoachFilter] = useState('all');
  const [selectedStudent, setSelectedStudent] = useState(null);

  // List of coaches for quick filter
  const coaches = [
    'all',
    'Mr. V. S. Kalyanaraghavan',
    'Mr. Sivarajan',
    'Ms. Vishnupriya',
    'Mr. Govindarajan',
    'Mr. Rajendran'
  ];

  // Combined filtering by category and coach
  const filteredStudents = students.filter((s) => {
    const matchesCategory =
      activeCategory === 'all' ||
      (activeCategory === 'podium' && (s.category === 'podium' || s.rank.includes('2nd') || s.rank.includes('4th') || s.rank.includes('5th'))) ||
      (activeCategory === 'ageGroup' && (s.division === 'U-9' || s.division === 'U-11' || s.division === 'U-13')) ||
      (activeCategory === 'fide' && s.typeBadge === 'FIDE RATED');

    const matchesCoach = coachFilter === 'all' || s.coach.toLowerCase().includes(coachFilter.toLowerCase());

    return matchesCategory && matchesCoach;
  });

  // Modal ESC Key listener
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setSelectedStudent(null);
    };
    if (selectedStudent) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedStudent]);

  return (
    /* Light warm background (#f8f5ec to #e8e0c9) matching About Us & Courses sections */
    <section className="py-24 bg-gradient-to-b from-[#f8f5ec] via-[#f4efe0] to-[#e8e0c9] relative overflow-hidden">
      {/* Subtle background chess watermark */}
      <div className="chess-pattern absolute inset-0 opacity-5 pointer-events-none"></div>

      <div className="container max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header (Light Theme with Dark Text & Gold Accents) */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span
            className="text-[#c9b26d] uppercase tracking-widest font-semibold text-sm mb-4 inline-block relative"
            data-aos="fade-down"
          >
            Wall of Champions
            <span className="block w-16 h-0.5 bg-[#c9b26d] mx-auto mt-3"></span>
          </span>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-aos="fade-up">
            Hall of <span className="text-[#c9b26d]">Fame</span>
          </h2>

          <p className="text-gray-700 text-lg leading-relaxed" data-aos="fade-up" data-aos-delay="100">
            Celebrating our young champions from the Tamil Nadu State Level & FIDE Rated tournaments. Trained by certified mentors, winning with passion.
          </p>

          {/* Filter Pills (Clean Light Theme) */}
          <div className="flex flex-wrap justify-center gap-2.5 mt-8" data-aos="fade-up" data-aos-delay="200">
            {[
              { key: 'all', label: `All Achievers (${students.length})` },
              { key: 'podium', label: 'Podium Finishers (Top 5)' },
              { key: 'ageGroup', label: 'Age Group Stars (U-9 / U-11 / U-13)' },
              { key: 'fide', label: 'FIDE Rated & Classical' }
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveCategory(tab.key)}
                className={`px-5 py-2.5 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 shadow-sm ${
                  activeCategory === tab.key
                    ? 'bg-[#0d1b0f] text-[#c9b26d] shadow-md scale-105'
                    : 'bg-white text-gray-700 hover:text-gray-900 hover:bg-gray-50 border border-gray-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Coach Filter Dropdown */}
          <div className="flex items-center justify-center gap-3 mt-5" data-aos="fade-up" data-aos-delay="250">
            <span className="text-xs uppercase tracking-wider text-gray-600 font-semibold flex items-center gap-1.5">
              <i className="fas fa-user-tie text-[#c9b26d]"></i> Filter by Coach:
            </span>
            <select
              value={coachFilter}
              onChange={(e) => setCoachFilter(e.target.value)}
              className="bg-white text-gray-800 border border-gray-300 rounded-lg px-3 py-1.5 text-xs sm:text-sm focus:outline-none focus:border-[#c9b26d] shadow-sm font-medium"
            >
              <option value="all">All Certified Coaches</option>
              {coaches.filter((c) => c !== 'all').map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>
        </div>

        {/* 3x3 Responsive Grid honoring strict 864x1152 (3:4) proportions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredStudents.map((student, idx) => (
            <div
              key={student.id}
              onClick={() => setSelectedStudent(student)}
              className="group relative aspect-[3/4] rounded-2xl overflow-hidden bg-white border border-[#c9b26d]/40 hover:border-[#c9b26d] shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              data-aos="fade-up"
              data-aos-delay={(idx % 3) * 120 + 80}
            >
              {/* 4 Golden Corner Accents */}
              <span className="absolute top-3 left-3 w-4 h-4 border-t-2 border-l-2 border-[#c9b26d]/70 group-hover:border-[#c9b26d] transition-all duration-300 z-20 pointer-events-none"></span>
              <span className="absolute top-3 right-3 w-4 h-4 border-t-2 border-r-2 border-[#c9b26d]/70 group-hover:border-[#c9b26d] transition-all duration-300 z-20 pointer-events-none"></span>
              <span className="absolute bottom-3 left-3 w-4 h-4 border-b-2 border-l-2 border-[#c9b26d]/70 group-hover:border-[#c9b26d] transition-all duration-300 z-20 pointer-events-none"></span>
              <span className="absolute bottom-3 right-3 w-4 h-4 border-b-2 border-r-2 border-[#c9b26d]/70 group-hover:border-[#c9b26d] transition-all duration-300 z-20 pointer-events-none"></span>

              {/* Top Badges (Rank Pill + Match Tag) */}
              <div className="absolute top-4 left-4 right-4 z-20 flex items-center justify-between pointer-events-none">
                <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/95 border border-[#c9b26d]/60 shadow-md text-xs font-bold text-gray-900">
                  <i className="fas fa-medal text-[10px] text-[#c9b26d]"></i>
                  {student.rank}
                </div>

                <div className={`px-2.5 py-0.5 rounded text-[10px] font-extrabold tracking-wider uppercase shadow-md ${
                  student.typeBadge === 'FIDE RATED'
                    ? 'bg-[#1e3a8a] text-[#fde047] border border-[#fde047]/40'
                    : 'bg-gradient-to-r from-[#c9b26d] to-[#a1860a] text-white border border-[#c9b26d]'
                }`}>
                  {student.typeBadge}
                </div>
              </div>

              {/* Main Student Artwork (864x1152) */}
              <img
                src={student.image}
                alt={`${student.name} - ${student.rank}`}
                loading="lazy"
                className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-105"
                onError={(e) => {
                  e.currentTarget.src = "https://images.unsplash.com/photo-1529699211952-734e80c4d42b?auto=format&fit=crop&w=864&h=1152&q=80";
                }}
              />

              {/* Bottom Gradient Overlay for High Contrast Text */}
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/90 via-gray-950/40 to-transparent opacity-85 group-hover:opacity-95 transition-opacity duration-300 flex flex-col justify-end p-6 z-10">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-2xl font-serif font-bold text-white group-hover:text-[#c9b26d] transition-colors duration-200">
                    {student.name}
                  </h3>
                  {student.points && (
                    <span className="px-2 py-0.5 rounded bg-[#c9b26d] text-gray-950 text-xs font-bold shadow">
                      {student.points}
                    </span>
                  )}
                </div>

                <p className="text-xs font-medium text-gray-200 line-clamp-1 mb-2">
                  <i className="fas fa-chess-board text-[#c9b26d] mr-1.5"></i>
                  {student.event}
                </p>

                <div className="flex items-center justify-between text-xs text-[#c9b26d] pt-2 border-t border-white/20">
                  <span className="flex items-center gap-1 font-medium text-gray-200">
                    <i className="fas fa-user-tie text-[10px] text-[#c9b26d]"></i>
                    Coach: {student.coach.replace('Mr. ', '').replace('Ms. ', '')}
                  </span>
                  <span className="flex items-center gap-1 font-semibold group-hover:underline">
                    View Poster <i className="fas fa-arrow-right text-[10px] transform group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal for High-Resolution View */}
      {selectedStudent && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-fadeIn"
          onClick={() => setSelectedStudent(null)}
        >
          <div
            className="relative max-w-4xl w-full max-h-[92vh] bg-white border border-[#c9b26d]/60 rounded-2xl overflow-hidden shadow-2xl flex flex-col md:flex-row"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedStudent(null)}
              className="absolute top-4 right-4 z-30 w-10 h-10 rounded-full bg-black/60 hover:bg-[#c9b26d] hover:text-[#0d1b0f] text-white flex items-center justify-center transition-all duration-200 shadow-md"
              aria-label="Close"
            >
              <i className="fas fa-times text-lg"></i>
            </button>

            {/* Poster Media Column (Strict 3:4 ratio) */}
            <div className="md:w-3/5 bg-gray-950 flex items-center justify-center p-3">
              <img
                src={selectedStudent.image}
                alt={selectedStudent.name}
                className="max-h-[78vh] w-auto object-contain rounded-lg shadow-xl"
                onError={(e) => {
                  e.currentTarget.src = "https://images.unsplash.com/photo-1529699211952-734e80c4d42b?auto=format&fit=crop&w=864&h=1152&q=80";
                }}
              />
            </div>

            {/* Detailed Credentials Card (Light Theme) */}
            <div className="md:w-2/5 p-6 sm:p-8 flex flex-col justify-between bg-[#f8f5ec] border-t md:border-t-0 md:border-l border-gray-200 overflow-y-auto">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-3 py-1 rounded-full bg-[#c9b26d]/20 text-[#0d1b0f] text-xs font-bold uppercase tracking-wider border border-[#c9b26d]/50">
                    {selectedStudent.typeBadge}
                  </span>
                  {selectedStudent.points && (
                    <span className="px-2.5 py-1 rounded-full bg-[#0d1b0f] text-white text-xs font-bold">
                      Score: {selectedStudent.points}
                    </span>
                  )}
                </div>

                <h3 className="text-3xl font-serif font-bold text-gray-900 mb-1">
                  {selectedStudent.name}
                </h3>
                <h4 className="text-base font-semibold text-[#0d1b0f] mb-4 flex items-center gap-2">
                  <i className="fas fa-award text-[#c9b26d]"></i>
                  {selectedStudent.rank}
                </h4>

                <div className="space-y-3 text-xs sm:text-sm text-gray-700 py-3 border-y border-gray-300 mb-4 bg-white/70 p-3 rounded-xl">
                  <div>
                    <span className="text-gray-900 font-bold block">Coach & Mentor:</span>
                    {selectedStudent.coach}
                  </div>
                  <div>
                    <span className="text-gray-900 font-bold block">Tournament Event:</span>
                    {selectedStudent.event}
                  </div>
                  <div className="flex justify-between">
                    <div>
                      <span className="text-gray-900 font-bold block">Date:</span>
                      {selectedStudent.date}
                    </div>
                    <div>
                      <span className="text-gray-900 font-bold block">Venue:</span>
                      {selectedStudent.venue}
                    </div>
                  </div>
                </div>

                <p className="text-xs italic text-gray-600 leading-relaxed mb-4">
                  "{selectedStudent.quote}"
                </p>
              </div>

              <div className="pt-2">
                <Link
                  to="/contact"
                  className="chess-button-primary inline-block w-full text-center py-3 px-4 rounded-lg text-sm font-bold shadow-lg"
                >
                  Join Thirumal Chess Academy
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default HallOfFame;